import React from 'react';
export function RealProblem() {
  return <section className="bg-ink py-12 text-cream sm:py-24" aria-labelledby="problema" data-id="element-117" data-mp="2j87eoo96ym0w">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-118" data-mp="9axhzyfvm80a">
        <h2 id="problema" className="max-w-3xl font-display text-[1.6rem] font-semibold leading-tight sm:text-[2.75rem]" data-id="element-119" data-mp="3ri51iv1db1f8">
          El verdadero problema no sos vos. Es que nadie te enseñó el sistema completo.
        </h2>

        <div className="mt-9 grid gap-8 sm:mt-14 lg:grid-cols-[0.75fr_1.25fr] lg:items-center lg:gap-16" data-id="element-120" data-mp="3hrsbinasag1p">
          <div className="flex items-end gap-3 sm:gap-4" aria-hidden="true" data-id="element-121" data-mp="3mjtqigzc6kvf">
            <div className="flex-1 text-center" data-id="element-122" data-mp="37ue39az0kxkh">
              <div className="flex h-16 w-full items-center justify-center rounded-t-lg bg-cream/15 sm:h-24" data-id="element-123" data-mp="37vp71asgm5bl">
                <span className="font-display text-xl text-cream/70 sm:text-2xl" data-id="element-124" data-mp="3cqw2jvbks3pf">30%</span>
              </div>
              <p className="mt-2.5 text-[10px] uppercase tracking-[0.12em] text-cream/50 sm:text-xs" data-id="element-125" data-mp="2yvk2d8enhl14">
                Técnica
              </p>
            </div>
            <div className="flex-1 text-center" data-id="element-126" data-mp="3d7sfhvjauk9y">
              <div className="flex h-36 w-full items-center justify-center rounded-t-lg bg-champagne sm:h-56" data-id="element-127" data-mp="3981te54pwsbr">
                <span className="font-display text-2xl text-ink sm:text-3xl" data-id="element-128" data-mp="3n82spg5c3rp4">70%</span>
              </div>
              <p className="mt-2.5 text-[10px] uppercase tracking-[0.12em] text-champagne sm:text-xs" data-id="element-129" data-mp="3i86p3i0ju2a3">
                Negocio
              </p>
            </div>
          </div>

          <div className="space-y-4 text-[15px] leading-relaxed text-cream/75 sm:space-y-6 sm:text-lg" data-id="element-130" data-mp="2pk2hus2bxh5a">
            <p data-id="element-131" data-mp="348f7766ww1qt">
              Pintar uñas es el 30% del negocio. El otro 70% es{' '}
              <span className="text-champagne-light" data-id="element-132" data-mp="2zhyszjv9oc3e">posicionamiento, precio y atracción de clientas</span>. Sin
              ese 70%, la técnica no genera plata.
            </p>
            <p data-id="element-133" data-mp="2bqb7jhgrxt8i">
              Todas las manicuristas que ves con la agenda llena, viajando y comprando materiales de
              lujo no tienen más talento que vos. Tienen un sistema. Un método que combina técnica de
              élite con estrategias de negocio que funcionan en 2026.
            </p>
            <p data-id="element-134" data-mp="fn55qdw4mp7o">
              Ese sistema, hasta hoy, nadie lo había juntado en un solo lugar para el mercado hispano.
            </p>
            <p className="font-display text-xl text-cream sm:text-2xl" data-id="element-135" data-mp="oi2x3gjmltww">Hasta ahora.</p>
          </div>
        </div>
      </div>
    </section>;
}